import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import qute from "../../images/qute.jpg";
import "../../../src/product.css";

const Qute = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">QUTE</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={qute}
              alt="Bajaj Qute"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Qute is an eco-friendly, fuel efficient, and economically
              competitive vehicle for first and last mile transportation.
              What’s more, it’s a safe and affordable mode of transport for
              the commuter and provides employment for drivers and fleet owners.
            </p>

          </div>
        </section>

        {/* Specifications */}

        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>216.6 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>5 Forward + 1 Reverse Gear</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>399 kg</strong>
            </div>

            <div className="spec-card">
              <span>Max Speed</span>
              <strong>70 Kmph</strong>
            </div>

            <div className="spec-card">
              <span>Passenger Capacity</span>
              <strong>1D + 3</strong>
            </div>

            <div className="spec-card">
              <span>Body Type</span>
              <strong>Quadricycle</strong>
            </div>

            <div className="spec-card">
              <span>Number of Doors</span>
              <strong>4 Doors</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Qute;